import React, { useEffect, useState, useRef } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookOpenIcon, CheckIcon, ClockIcon, AwardIcon, UsersIcon, BuildingIcon, ShieldCheckIcon, BarChartIcon, FileTextIcon, DownloadIcon, ChevronRightIcon, ChevronDownIcon, StarIcon, PlayCircleIcon, CheckCircleIcon, BadgeCheckIcon, ArrowRightIcon, PlusIcon, MinusIcon, UserIcon, LockIcon, GraduationCapIcon, CreditCardIcon, TrendingUpIcon, LightbulbIcon, BrainIcon, ThumbsUpIcon, MessageCircleIcon, AlertCircleIcon, UtensilsIcon, WashingMachineIcon, ThermometerIcon, ShieldIcon, MapPinIcon, ScrollIcon, CalendarIcon, ClipboardCheckIcon } from 'lucide-react';
export const HACCPFoodSafetyPage = () => {
  return <div className="flex flex-col min-h-screen w-full bg-white text-charcoal" data-id="element-1500">
      <Header data-id="element-1501" />
      <main className="flex-grow" data-id="element-1502">
        <HeroSection data-id="element-1503" />
        <TrustBanner data-id="element-1504" />
        <CourseHighlights data-id="element-1505" />
        <CourseOverview data-id="element-1506" />
        <CombinedTrainingSection data-id="element-1507" />
        <LegalRequirements data-id="element-1508" />
        <LearningOutcomes data-id="element-1509" />
        <CourseCurriculum data-id="element-1510" />
        <EnrollmentOptions data-id="element-1511" />
        <CertificationSection data-id="element-1512" />
        <FaqSection data-id="element-1513" />
        <CtaSection data-id="element-1514" />
      </main>
      <Footer data-id="element-1515" />
    </div>;
};
const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    setIsVisible(true);
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative pt-28 pb-20 md:pt-36 md:pb-28 overflow-hidden" data-id="element-1516">
      {/* Background with enhanced overlay */}
      <div className="absolute inset-0 z-0" data-id="element-1517">
        <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Professional Kitchen Environment in Ireland" className="w-full h-full object-cover" data-id="element-1518" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/85 to-charcoal/75" data-id="element-1519"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03] mix-blend-soft-light" data-id="element-1520"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1521">
        <div className="max-w-3xl" data-id="element-1522">
          <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-1523">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-teal/20 backdrop-blur-sm border border-teal/30 mb-6" data-id="element-1524">
              <MapPinIcon className="h-4 w-4 text-aqua mr-2" data-id="element-1525" />
              <span className="text-white/90 text-sm font-medium" data-id="element-1526">
                FSAI Compliant Training for Ireland
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight" data-id="element-1527">
              Level 1 Food Safety{' '}
              <span className="text-gradient bg-gradient-to-r from-teal to-aqua bg-clip-text text-transparent" data-id="element-1528">
                Training
              </span>
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed" data-id="element-1529">
              The essential induction programme for all food handlers in
              Ireland. Fully aligned with FSAI requirements to protect consumers
              and meet your legal obligations.
            </p>
            <div className="flex items-center gap-6 mb-8" data-id="element-1530">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-1531">
                <ClockIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-1532" />
                <span className="text-white" data-id="element-1533">Complete in 2 Hours</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-1534">
                <AwardIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-1535" />
                <span className="text-white" data-id="element-1536">FSAI Compliant</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-1537">
              <a href="#individual-enrollment" className="px-6 py-3.5 bg-teal text-white font-medium rounded-lg hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 text-center shadow-lg flex items-center justify-center" data-id="element-1538">
                Enroll Now - Just €19
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-1539" />
              </a>
              <a href="#preview-module" className="px-6 py-3.5 bg-transparent text-white font-medium rounded-lg border-2 border-white hover:bg-white/10 transition-all duration-300 text-center flex items-center justify-center" data-id="element-1540">
                <PlayCircleIcon className="mr-2 h-5 w-5" data-id="element-1541" />
                Preview Course
              </a>
            </div>
            {/* Money Back Guarantee Banner */}
            <div className="bg-gradient-to-r from-amber-400/90 to-amber-500/90 rounded-lg p-4 shadow-lg border border-amber-300" data-id="element-1542">
              <div className="flex items-center" data-id="element-1543">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1544">
                  <ShieldIcon className="h-6 w-6 text-white" data-id="element-1545" />
                </div>
                <div data-id="element-1546">
                  <h3 className="font-bold text-white text-lg" data-id="element-1547">
                    100% Acceptance Guarantee
                  </h3>
                  <p className="text-white/90" data-id="element-1548">
                    If your certificate is not accepted by regulators, we'll
                    refund your purchase in full.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const TrustBanner = () => {
  return <section className="py-4 bg-gray-50 border-y border-gray-200" data-id="element-1549">
      <div className="container mx-auto px-4" data-id="element-1550">
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-6 text-center md:text-left" data-id="element-1551">
          <p className="text-charcoal/70 font-medium" data-id="element-1552">
            Trusted by leading food businesses across Ireland:
          </p>
          <div className="flex flex-wrap justify-center gap-8" data-id="element-1553">
            <div className="text-charcoal/80 font-semibold" data-id="element-1554">Dunnes Stores</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-1555">SuperValu</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-1556">Avoca</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-1557">Musgrave Group</div>
          </div>
        </div>
      </div>
    </section>;
};
const CourseHighlights = () => {
  return <section className="py-12 bg-gray-50" data-id="element-1558">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1559">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1560">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-1561">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1562">
              <LockIcon className="h-6 w-6 text-teal" data-id="element-1563" />
            </div>
            <div data-id="element-1564">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-1565">
                Instant Access
              </h3>
              <p className="text-charcoal/70" data-id="element-1566">
                Start training immediately after enrollment with our easy-to-use
                learning platform
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-1567">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1568">
              <GraduationCapIcon className="h-6 w-6 text-teal" data-id="element-1569" />
            </div>
            <div data-id="element-1570">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-1571">
                FSAI Compliant
              </h3>
              <p className="text-charcoal/70" data-id="element-1572">
                Meets all Food Safety Authority of Ireland training requirements
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-1573">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1574">
              <BarChartIcon className="h-6 w-6 text-teal" data-id="element-1575" />
            </div>
            <div data-id="element-1576">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-1577">
                Team Management
              </h3>
              <p className="text-charcoal/70" data-id="element-1578">
                Free dashboard to assign, track, and manage training for your
                entire team
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CourseOverview = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-20 bg-white" data-id="element-1579">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1580">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1581">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1582">
            <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-1583" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1584">
            Course Overview
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1585">
            Our Level 1 Food Safety course provides essential knowledge for
            anyone who works with or around food in Ireland
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-1586">
          <div className={`transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-1587">
            <div className="prose prose-lg max-w-none text-charcoal/80" data-id="element-1588">
              <p data-id="element-1589">
                The Level 1 Food Safety Training Course is the essential
                induction programme for all food handlers in Ireland. This
                comprehensive course covers the fundamental principles of food
                safety, providing you with the essential knowledge to prevent
                contamination, protect consumers, and meet your legal
                obligations under Irish food law.
              </p>
              <p data-id="element-1590">
                Whether you're just starting your career in the food industry or
                need to fulfill compliance requirements, this course delivers
                the critical information you need in a clear, engaging format
                that's easy to understand and apply in your workplace.
              </p>
              <p data-id="element-1591">
                Fully compliant with Food Safety Authority of Ireland (FSAI)
                Level 1 training requirements, this certification is recognized
                by employers and Environmental Health Officers throughout
                Ireland, making it the perfect foundation for your food safety
                training.
              </p>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-1592">
              <div className="flex items-center" data-id="element-1593">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-1594" />
                <span data-id="element-1595">FSAI compliant</span>
              </div>
              <div className="flex items-center" data-id="element-1596">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-1597" />
                <span data-id="element-1598">Nationally recognized</span>
              </div>
              <div className="flex items-center" data-id="element-1599">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-1600" />
                <span data-id="element-1601">Valid for 2-3 years</span>
              </div>
              <div className="flex items-center" data-id="element-1602">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-1603" />
                <span data-id="element-1604">Meets legal requirements</span>
              </div>
            </div>
          </div>
          <div className={`transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'} delay-200`} data-id="element-1605">
            <div className="bg-gray-50 rounded-2xl overflow-hidden" data-id="element-1606">
              <div className="p-8" data-id="element-1607">
                <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-1608">
                  Course Details
                </h3>
                <div className="space-y-6" data-id="element-1609">
                  <div className="flex" data-id="element-1610">
                    <ClockIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-1611" />
                    <div data-id="element-1612">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-1613">Duration</h4>
                      <p className="text-charcoal/70" data-id="element-1614">
                        Approximately 2 hours to complete
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1615">
                    <BookOpenIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-1616" />
                    <div data-id="element-1617">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-1618">
                        Course Format
                      </h4>
                      <p className="text-charcoal/70" data-id="element-1619">
                        Interactive video lessons with quizzes
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1620">
                    <AwardIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-1621" />
                    <div data-id="element-1622">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-1623">
                        Certification
                      </h4>
                      <p className="text-charcoal/70" data-id="element-1624">
                        Instant downloadable certificate
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1625">
                    <ShieldCheckIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-1626" />
                    <div data-id="element-1627">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-1628">
                        Compliance
                      </h4>
                      <p className="text-charcoal/70" data-id="element-1629">
                        Meets FSAI Level 1 requirements
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CombinedTrainingSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-20 bg-gray-50" data-id="element-1630">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1631">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1632">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1633">
            <UsersIcon className="h-6 w-6 text-teal" data-id="element-1634" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1635">
            Who Should Take This Course & Why
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1636">
            Mandatory training for Irish food handlers with industry-recognized
            benefits
          </p>
        </div>
        {/* Who Should Take This Course Section - Updated with more detailed information */}
        <div className="max-w-6xl mx-auto mb-16" data-id="element-1637">
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 mb-10" data-id="element-1638">
            <h3 className="text-2xl font-bold mb-5 text-charcoal" data-id="element-1639">
              Mandatory Training in Ireland
            </h3>
            <p className="text-charcoal/80 mb-6" data-id="element-1640">
              The HACCP Level 1 Food Safety Training is the mandatory induction
              training for all new food handlers in Ireland, as outlined by the
              Food Safety Authority of Ireland (FSAI). It is delivered in two
              stages:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1641">
              <div className="bg-teal/5 rounded-lg p-5 border border-teal/10" data-id="element-1642">
                <div className="flex items-center mb-3" data-id="element-1643">
                  <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-1644">
                    <span className="font-bold text-teal" data-id="element-1645">I</span>
                  </div>
                  <h4 className="text-lg font-bold text-charcoal" data-id="element-1646">Stage I</h4>
                </div>
                <p className="text-charcoal/70" data-id="element-1647">
                  Must be completed{' '}
                  <span className="font-semibold text-teal" data-id="element-1648">
                    before or as soon as
                  </span>{' '}
                  an employee begins handling food.
                </p>
              </div>
              <div className="bg-teal/5 rounded-lg p-5 border border-teal/10" data-id="element-1649">
                <div className="flex items-center mb-3" data-id="element-1650">
                  <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-1651">
                    <span className="font-bold text-teal" data-id="element-1652">II</span>
                  </div>
                  <h4 className="text-lg font-bold text-charcoal" data-id="element-1653">Stage II</h4>
                </div>
                <p className="text-charcoal/70" data-id="element-1654">
                  Must be completed{' '}
                  <span className="font-semibold text-teal" data-id="element-1655">
                    within the first month
                  </span>{' '}
                  of employment.
                </p>
              </div>
            </div>
            <p className="text-charcoal/80 mb-4" data-id="element-1656">
              Level 1 ensures that all staff gain the essential knowledge to
              handle food safely from day one. It is the starting point for all
              food handlers and provides the foundation to progress to HACCP
              Level 2 Food Safety Training, which builds on this induction and
              is required for staff who prepare or handle open or high-risk
              foods.
            </p>
          </div>
          <h3 className="text-2xl font-bold mb-8 text-charcoal text-center" data-id="element-1657">
            Perfect For
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1658">
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1659">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1660">
                <UtensilsIcon className="h-6 w-6 text-teal" data-id="element-1661" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1662">
                Food Service Staff
              </h3>
              <p className="text-charcoal/70" data-id="element-1663">
                Kitchen porters, wait staff, baristas, and catering assistants
                in restaurants, cafés, hotels, bars, and takeaways throughout
                Ireland.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1664">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1665">
                <UserIcon className="h-6 w-6 text-teal" data-id="element-1666" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1667">
                Retail Food Handlers
              </h3>
              <p className="text-charcoal/70" data-id="element-1668">
                Deli and counter workers, grocery staff, and anyone handling
                food products in retail environments across Ireland.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1669">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1670">
                <LockIcon className="h-6 w-6 text-teal" data-id="element-1671" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1672">
                New Employees
              </h3>
              <p className="text-charcoal/70" data-id="element-1673">
                Entry-level staff who must complete induction training before
                food handling begins, as required by FSAI guidelines.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1674">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1675">
                <ClockIcon className="h-6 w-6 text-teal" data-id="element-1676" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1677">
                Production Facilities
              </h3>
              <p className="text-charcoal/70" data-id="element-1678">
                Workers in food production and manufacturing facilities who need
                to understand basic food safety principles.
              </p>
            </div>
          </div>
        </div>
        {/* Why Choose Our Training Section */}
        <div className="max-w-6xl mx-auto" data-id="element-1679">
          <h3 className="text-2xl font-bold mb-8 text-charcoal text-center" data-id="element-1680">
            Key Benefits
          </h3>
          <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-1681">
            {[{
            icon: <ShieldCheckIcon className="h-6 w-6 text-teal" data-id="element-1682" />,
            title: 'Legal Compliance',
            description: 'Meets all FSAI regulatory requirements for food handlers in Ireland'
          }, {
            icon: <BuildingIcon className="h-6 w-6 text-teal" data-id="element-1683" />,
            title: 'Industry Standard',
            description: 'Recognized by leading Irish food service establishments and health inspectors'
          }, {
            icon: <TrendingUpIcon className="h-6 w-6 text-teal" data-id="element-1684" />,
            title: 'Career Advancement',
            description: 'Enhances employment prospects in the Irish food industry and demonstrates commitment'
          }, {
            icon: <GraduationCapIcon className="h-6 w-6 text-teal" data-id="element-1685" />,
            title: 'Knowledge Foundation',
            description: 'Creates a solid base for further specialized food safety qualifications, including Level 2 HACCP'
          }, {
            icon: <BadgeCheckIcon className="h-6 w-6 text-teal" data-id="element-1686" />,
            title: 'Quality Assurance',
            description: 'Helps Irish businesses maintain high standards and customer confidence'
          }, {
            icon: <AwardIcon className="h-6 w-6 text-teal" data-id="element-1687" />,
            title: 'Audit Preparation',
            description: 'Ensures your business is prepared for Environmental Health Officer inspections'
          }].map((benefit, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition-all duration-300" style={{
            transitionDelay: `${index * 100}ms`,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            opacity: isVisible ? 1 : 0,
            transition: 'all 0.7s ease'
          }} data-id="element-1688">
                <div className="p-8" data-id="element-1689">
                  <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-5" data-id="element-1690">
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-1691">
                    {benefit.title}
                  </h3>
                  <p className="text-charcoal/70" data-id="element-1692">{benefit.description}</p>
                </div>
              </div>)}
          </div>
        </div>
        {/* Testimonial-style banner */}
        <div className="max-w-4xl mx-auto mt-16 p-8 bg-white rounded-xl shadow-lg border border-gray-100 flex flex-col md:flex-row items-center gap-8" data-id="element-1693">
          <div className="flex-1" data-id="element-1694">
            <div className="flex flex-wrap items-center mb-4 gap-2" data-id="element-1695">
              <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-1696">
                <span className="text-teal font-medium" data-id="element-1697">100% Online</span>
              </div>
              <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-1698">
                <span className="text-teal font-medium" data-id="element-1699">Self-Paced</span>
              </div>
              <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-1700">
                <span className="text-teal font-medium" data-id="element-1701">
                  Interactive Videos
                </span>
              </div>
              <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-1702">
                <span className="text-teal font-medium" data-id="element-1703">
                  Unlimited Attempts
                </span>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-charcoal mb-2" data-id="element-1704">
              Used by 5,000+ Irish Food Businesses
            </h3>
            <p className="text-charcoal/70" data-id="element-1705">
              From small cafés to major restaurant chains and retailers, our
              certification is trusted industry-wide to meet Irish compliance
              requirements.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-1706">
            <a href="#enrollment-options" className="px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 text-center shadow-lg inline-block" data-id="element-1707">
              Get Certified Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const LegalRequirements = () => {
  return <section className="py-20 bg-white" data-id="element-1708">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1709">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1710">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1711">
            <ScrollIcon className="h-6 w-6 text-teal" data-id="element-1712" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1713">
            Legal Requirements for Food Safety Level 1
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1714">
            Understanding your legal obligations under Irish food safety law
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-sm mb-12" data-id="element-1715">
          <div className="flex items-start mb-6" data-id="element-1716">
            <AlertCircleIcon className="h-8 w-8 text-teal mr-4 flex-shrink-0 mt-1" data-id="element-1717" />
            <div data-id="element-1718">
              <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-1719">
                Legal Requirement in Ireland
              </h3>
              <p className="text-charcoal/80 mb-4" data-id="element-1720">
                In Ireland, it is a legal requirement that all food handlers are
                trained commensurate with their work activity. The FSAI Level 1
                guidelines set out clear timelines for compliance.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-1721">
            <div className="bg-white p-6 rounded-xl border border-gray-200" data-id="element-1722">
              <div className="flex items-center mb-4" data-id="element-1723">
                <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-4" data-id="element-1724">
                  <CalendarIcon className="h-5 w-5 text-teal" data-id="element-1725" />
                </div>
                <h4 className="text-lg font-bold text-charcoal" data-id="element-1726">
                  Stage I Induction
                </h4>
              </div>
              <p className="text-charcoal/70" data-id="element-1727">
                Must be completed{' '}
                <span className="font-semibold text-teal" data-id="element-1728">before</span> an
                employee begins handling food.
              </p>
              <div className="mt-4 p-3 bg-teal/5 rounded-lg border border-teal/10" data-id="element-1729">
                <p className="text-sm text-charcoal/80" data-id="element-1730">
                  Covers basic hygiene, contamination, and safe handling
                  principles.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-gray-200" data-id="element-1731">
              <div className="flex items-center mb-4" data-id="element-1732">
                <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-4" data-id="element-1733">
                  <CalendarIcon className="h-5 w-5 text-teal" data-id="element-1734" />
                </div>
                <h4 className="text-lg font-bold text-charcoal" data-id="element-1735">
                  Stage II Induction
                </h4>
              </div>
              <p className="text-charcoal/70" data-id="element-1736">
                Must be completed{' '}
                <span className="font-semibold text-teal" data-id="element-1737">
                  within the first month
                </span>{' '}
                of employment.
              </p>
              <div className="mt-4 p-3 bg-teal/5 rounded-lg border border-teal/10" data-id="element-1738">
                <p className="text-sm text-charcoal/80" data-id="element-1739">
                  Expands knowledge with more detailed food safety practices and
                  principles.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 p-4 bg-amber-50 rounded-lg border border-amber-100" data-id="element-1740">
            <div className="flex" data-id="element-1741">
              <ShieldCheckIcon className="h-6 w-6 text-amber-600 mr-3 flex-shrink-0 mt-1" data-id="element-1742" />
              <p className="text-charcoal/80" data-id="element-1743">
                This ensures that every food worker understands the fundamentals
                of safe food handling from the very start of their role,
                protecting public health and meeting regulatory requirements.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-1744">
          <div className="flex items-center justify-center mb-8" data-id="element-1745">
            <div className="h-px bg-gray-200 flex-grow" data-id="element-1746"></div>
            <span className="px-4 text-charcoal/60 font-medium" data-id="element-1747">
              FSAI COMPLIANCE
            </span>
            <div className="h-px bg-gray-200 flex-grow" data-id="element-1748"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1749">
            <div className="flex" data-id="element-1750">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1751">
                <ClipboardCheckIcon className="h-6 w-6 text-teal" data-id="element-1752" />
              </div>
              <div data-id="element-1753">
                <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1754">
                  Documentation Requirements
                </h3>
                <p className="text-charcoal/70" data-id="element-1755">
                  Food businesses must maintain records of staff training,
                  including certificates and completion dates, which may be
                  requested during EHO inspections.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-1756">
              <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1757">
                <AwardIcon className="h-6 w-6 text-teal" data-id="element-1758" />
              </div>
              <div data-id="element-1759">
                <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1760">
                  Certification Renewal
                </h3>
                <p className="text-charcoal/70" data-id="element-1761">
                  Certificates should be refreshed every 2–3 years or sooner if
                  roles, legislation, or company practices change to maintain
                  compliance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const LearningOutcomes = () => {
  return <section className="py-20 bg-gray-50" data-id="element-1762">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1763">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1764">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1765">
            <CheckIcon className="h-6 w-6 text-teal" data-id="element-1766" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1767">
            What You'll Learn in This Food Safety Course
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1768">
            This food safety course is designed to be clear, practical, and easy
            to follow
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-1769">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1770">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1771">
              <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-1772" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1773">
              Food Safety Fundamentals
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1774">
              Explain the difference between food safety and food hygiene, and
              understand food contamination and cross-contamination principles.
            </p>
            <ul className="space-y-2" data-id="element-1775">
              <li className="flex items-start" data-id="element-1776">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1777" />
                <span className="text-charcoal/80" data-id="element-1778">
                  Safety vs. hygiene concepts
                </span>
              </li>
              <li className="flex items-start" data-id="element-1779">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1780" />
                <span className="text-charcoal/80" data-id="element-1781">Contamination types</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1782">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1783">
              <WashingMachineIcon className="h-6 w-6 text-teal" data-id="element-1784" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1785">
              Personal Hygiene
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1786">
              Learn proper handwashing techniques, maintain personal hygiene,
              and understand proper uniform practices for food safety.
            </p>
            <ul className="space-y-2" data-id="element-1787">
              <li className="flex items-start" data-id="element-1788">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1789" />
                <span className="text-charcoal/80" data-id="element-1790">Handwashing procedures</span>
              </li>
              <li className="flex items-start" data-id="element-1791">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1792" />
                <span className="text-charcoal/80" data-id="element-1793">Uniform maintenance</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1794">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1795">
              <UtensilsIcon className="h-6 w-6 text-teal" data-id="element-1796" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1797">
              Safe Food Handling
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1798">
              Handle, prepare, and store food safely to prevent hazards and
              maintain food safety standards in the workplace.
            </p>
            <ul className="space-y-2" data-id="element-1799">
              <li className="flex items-start" data-id="element-1800">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1801" />
                <span className="text-charcoal/80" data-id="element-1802">
                  Safe preparation methods
                </span>
              </li>
              <li className="flex items-start" data-id="element-1803">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1804" />
                <span className="text-charcoal/80" data-id="element-1805">Storage best practices</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1806">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1807">
              <ThermometerIcon className="h-6 w-6 text-teal" data-id="element-1808" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1809">
              Temperature Control
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1810">
              Understand the critical temperature zones and how to monitor food
              temperatures to prevent bacterial growth.
            </p>
            <ul className="space-y-2" data-id="element-1811">
              <li className="flex items-start" data-id="element-1812">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1813" />
                <span className="text-charcoal/80" data-id="element-1814">Danger zone awareness</span>
              </li>
              <li className="flex items-start" data-id="element-1815">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1816" />
                <span className="text-charcoal/80" data-id="element-1817">Temperature monitoring</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1818">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1819">
              <ShieldCheckIcon className="h-6 w-6 text-teal" data-id="element-1820" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1821">
              Cleaning & Sanitising
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1822">
              Apply correct cleaning and sanitising procedures to maintain a
              safe food environment and prevent contamination.
            </p>
            <ul className="space-y-2" data-id="element-1823">
              <li className="flex items-start" data-id="element-1824">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1825" />
                <span className="text-charcoal/80" data-id="element-1826">Sanitising methods</span>
              </li>
              <li className="flex items-start" data-id="element-1827">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1828" />
                <span className="text-charcoal/80" data-id="element-1829">Cleaning schedules</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1830">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1831">
              <AlertCircleIcon className="h-6 w-6 text-teal" data-id="element-1832" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-1833">
              HACCP Awareness
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-1834">
              Recognise the importance of allergens and HACCP (Hazard Analysis
              and Critical Control Points) in food safety management.
            </p>
            <ul className="space-y-2" data-id="element-1835">
              <li className="flex items-start" data-id="element-1836">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1837" />
                <span className="text-charcoal/80" data-id="element-1838">HACCP principles</span>
              </li>
              <li className="flex items-start" data-id="element-1839">
                <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1840" />
                <span className="text-charcoal/80" data-id="element-1841">Allergen management</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-12 p-6 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-1842">
          <div className="flex items-center" data-id="element-1843">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1844">
              <TrendingUpIcon className="h-6 w-6 text-teal" data-id="element-1845" />
            </div>
            <div data-id="element-1846">
              <h3 className="text-xl font-bold text-charcoal" data-id="element-1847">
                Foundation for Advanced Training
              </h3>
              <p className="text-charcoal/70" data-id="element-1848">
                This training also introduces the basic principles of HACCP,
                providing a solid foundation for further learning in Level 2
                HACCP training, which is legally required for those working with
                high-risk or open foods.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CourseCurriculum = () => {
  const [openModule, setOpenModule] = useState(1);
  const toggleModule = moduleId => {
    setOpenModule(openModule === moduleId ? null : moduleId);
  };
  const modules = [{
    id: 1,
    title: 'Introduction to Food Safety in Ireland',
    lessons: ['Irish Food Safety Regulatory Framework', 'Role of the Food Safety Authority of Ireland (FSAI)', 'Legal Responsibilities of Food Handlers'],
    duration: '15 minutes'
  }, {
    id: 2,
    title: 'Food Safety Hazards and Contamination',
    lessons: ['Biological, Chemical, and Physical Hazards', 'Cross-Contamination Prevention', 'High-Risk Foods in the Irish Context'],
    duration: '25 minutes'
  }, {
    id: 3,
    title: 'Personal Hygiene for Food Handlers',
    lessons: ['Handwashing Techniques and Frequency', 'Appropriate Workwear and PPE', 'Reporting Illness and Exclusion Periods'],
    duration: '20 minutes'
  }, {
    id: 4,
    title: 'Safe Food Handling Practices',
    lessons: ['Safe Storage and Stock Rotation', 'Temperature Control and Monitoring', 'Food Preparation Guidelines'],
    duration: '25 minutes'
  }, {
    id: 5,
    title: 'Cleaning and Sanitising',
    lessons: ['Cleaning vs. Sanitising Procedures', 'Chemical Safety and Storage', 'Cleaning Schedules and Documentation'],
    duration: '15 minutes'
  }, {
    id: 6,
    title: 'Introduction to HACCP and Allergens',
    lessons: ['Basic HACCP Principles', 'Critical Control Points', 'Allergen Management in Irish Food Businesses'],
    duration: '20 minutes'
  }];
  return <section className="py-20 bg-white" data-id="element-1849">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1850">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1851">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1852">
            <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-1853" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1854">
            Course Curriculum
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1855">
            Our comprehensive curriculum covers all essential aspects of Level 1
            Food Safety for Ireland
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-1856">
          {modules.map(module => <div key={module.id} className="mb-4 border border-gray-200 rounded-xl overflow-hidden" data-id="element-1857">
              <button onClick={() => toggleModule(module.id)} className="flex items-center justify-between w-full p-5 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-1858">
                <div className="flex items-center" data-id="element-1859">
                  <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1860">
                    <span className="font-bold text-teal" data-id="element-1861">{module.id}</span>
                  </div>
                  <div data-id="element-1862">
                    <h3 className="text-lg font-bold text-charcoal" data-id="element-1863">
                      {module.title}
                    </h3>
                    <p className="text-charcoal/60 text-sm" data-id="element-1864">
                      {module.duration}
                    </p>
                  </div>
                </div>
                {openModule === module.id ? <MinusIcon className="h-5 w-5 text-teal" data-id="element-1865" /> : <PlusIcon className="h-5 w-5 text-teal" data-id="element-1866" />}
              </button>
              {openModule === module.id && <div className="p-5 bg-gray-50 border-t border-gray-200" data-id="element-1867">
                  <ul className="space-y-3" data-id="element-1868">
                    {module.lessons.map((lesson, index) => <li key={index} className="flex items-start" data-id="element-1869">
                        <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1870" />
                        <span className="text-charcoal/80" data-id="element-1871">{lesson}</span>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
          <div className="mt-10 p-6 bg-teal/10 rounded-xl" data-id="element-1872">
            <div className="flex items-start" data-id="element-1873">
              <AwardIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0 mt-1" data-id="element-1874" />
              <div data-id="element-1875">
                <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-1876">
                  Final Assessment
                </h3>
                <p className="text-charcoal/70 mb-2" data-id="element-1877">
                  Complete a comprehensive assessment to test your knowledge and
                  earn your certification.
                </p>
                <p className="text-charcoal/70" data-id="element-1878">
                  <strong data-id="element-1879">Pass Mark:</strong> 70% | <strong data-id="element-1880">Time Limit:</strong>{' '}
                  30 minutes | <strong data-id="element-1881">Attempts:</strong> Unlimited
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const EnrollmentOptions = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section id="enrollment-options" ref={sectionRef} className="py-20 bg-gray-50" data-id="element-1882">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1883">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1884">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1885">
            <UsersIcon className="h-6 w-6 text-teal" data-id="element-1886" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1887">
            Enrollment Options
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-1888">
            Choose the enrollment option that works best for you or your team
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1889">
          <div id="individual-enrollment" className={`bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-1890">
            <div className="p-8" data-id="element-1891">
              <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-1892">
                <UserIcon className="h-7 w-7 text-teal" data-id="element-1893" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-charcoal" data-id="element-1894">
                Individual Enrollment
              </h3>
              <p className="text-charcoal/70 mb-6" data-id="element-1895">
                Perfect for individual food handlers who need immediate access
                to FSAI-compliant training.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1896">
                <div className="flex items-start" data-id="element-1897">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1898" />
                  <p className="text-charcoal/80" data-id="element-1899">
                    Instant access to course materials
                  </p>
                </div>
                <div className="flex items-start" data-id="element-1900">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1901" />
                  <p className="text-charcoal/80" data-id="element-1902">Learn at your own pace</p>
                </div>
                <div className="flex items-start" data-id="element-1903">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1904" />
                  <p className="text-charcoal/80" data-id="element-1905">
                    Automatic certification upon completion
                  </p>
                </div>
                <div className="flex items-start" data-id="element-1906">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1907" />
                  <p className="text-charcoal/80" data-id="element-1908">
                    Lifetime access to your certificate
                  </p>
                </div>
              </div>
              <div className="pt-6 border-t border-gray-100" data-id="element-1909">
                <div className="flex items-end mb-6" data-id="element-1910">
                  <span className="text-3xl font-bold text-charcoal" data-id="element-1911">€19</span>
                  <span className="text-charcoal/60 ml-2" data-id="element-1912">per person</span>
                </div>
                <a href="/checkout/individual" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center shadow-md" data-id="element-1913">
                  Enroll Now
                </a>
              </div>
            </div>
          </div>
          <div id="team-enrollment" className={`bg-charcoal rounded-xl shadow-lg overflow-hidden transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'} delay-200`} data-id="element-1914">
            <div className="p-8 text-white" data-id="element-1915">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6" data-id="element-1916">
                <BuildingIcon className="h-7 w-7 text-aqua" data-id="element-1917" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-1918">
                Team & Business Enrollment
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1919">
                Ideal for Irish food businesses needing to train multiple
                employees with management tools included.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1920">
                <div className="flex items-start" data-id="element-1921">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-1922" />
                  <p className="text-white/80" data-id="element-1923">
                    Free manager dashboard included
                  </p>
                </div>
                <div className="flex items-start" data-id="element-1924">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-1925" />
                  <p className="text-white/80" data-id="element-1926">Bulk enrollment capabilities</p>
                </div>
                <div className="flex items-start" data-id="element-1927">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-1928" />
                  <p className="text-white/80" data-id="element-1929">
                    Progress tracking and reporting
                  </p>
                </div>
                <div className="flex items-start" data-id="element-1930">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-1931" />
                  <p className="text-white/80" data-id="element-1932">
                    Certificate management for all users
                  </p>
                </div>
              </div>
              <div className="pt-6 border-t border-white/10" data-id="element-1933">
                <div className="mb-6" data-id="element-1934">
                  <div className="flex items-end" data-id="element-1935">
                    <span className="text-3xl font-bold" data-id="element-1936">€19</span>
                    <span className="text-white/60 ml-2" data-id="element-1937">per license</span>
                  </div>
                  <p className="text-white/60 text-sm mt-1" data-id="element-1938">
                    Volume discounts available for 10+ licenses
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1939">
                  <a href="/checkout/team" className="block py-3 bg-aqua text-white font-medium rounded-lg hover:bg-aqua/90 transition-all duration-300 text-center shadow-md" data-id="element-1940">
                    Buy Now
                  </a>
                  <a href="/contact" className="block py-3 bg-transparent text-white font-medium rounded-lg border border-white/30 hover:bg-white/10 transition-all duration-300 text-center" data-id="element-1941">
                    Contact Sales
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto mt-16 bg-white rounded-xl p-6 shadow-sm border border-gray-200" data-id="element-1942">
          <h3 className="text-xl font-bold mb-4 text-charcoal" data-id="element-1943">
            Volume Discounts
          </h3>
          <div className="overflow-x-auto" data-id="element-1944">
            <table className="w-full" data-id="element-1945">
              <thead data-id="element-1946">
                <tr className="border-b border-gray-200" data-id="element-1947">
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-1948">
                    Number of Licenses
                  </th>
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-1949">
                    Price Per License
                  </th>
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-1950">Savings</th>
                </tr>
              </thead>
              <tbody data-id="element-1951">
                <tr className="border-b border-gray-100" data-id="element-1952">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1953">1-9</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1954">€19</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1955">-</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-1956">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1957">10-49</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1958">€17</td>
                  <td className="py-3 px-4 text-teal" data-id="element-1959">10% off</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-1960">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1961">50-99</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1962">€15</td>
                  <td className="py-3 px-4 text-teal" data-id="element-1963">20% off</td>
                </tr>
                <tr data-id="element-1964">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1965">100+</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-1966">€13</td>
                  <td className="py-3 px-4 text-teal" data-id="element-1967">30% off</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
};
const CertificationSection = () => {
  return <section className="py-20 bg-white" data-id="element-1968">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1969">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-1970">
          <div data-id="element-1971">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-1972">
              <AwardIcon className="h-6 w-6 text-teal" data-id="element-1973" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-1974">
              Accredited Food Safety Certificate (Ireland)
            </h2>
            <p className="text-lg text-charcoal/70 mb-6" data-id="element-1975">
              On successful completion, you will receive a Level 1 Food Safety
              Certificate that is fully recognized throughout Ireland and
              compliant with all FSAI requirements.
            </p>
            <div className="space-y-4 mb-8" data-id="element-1976">
              <div className="flex items-start" data-id="element-1977">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1978" />
                <div data-id="element-1979">
                  <p className="font-medium text-charcoal" data-id="element-1980">FSAI Aligned</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-1981">
                    Fully compliant with Food Safety Authority of Ireland Level
                    1 requirements
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1982">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1983" />
                <div data-id="element-1984">
                  <p className="font-medium text-charcoal" data-id="element-1985">
                    Nationally Recognized
                  </p>
                  <p className="text-charcoal/60 text-sm" data-id="element-1986">
                    Accepted by Irish employers, Environmental Health Officers
                    (EHOs), and food safety inspectors
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1987">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1988" />
                <div data-id="element-1989">
                  <p className="font-medium text-charcoal" data-id="element-1990">Instant Download</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-1991">
                    Downloadable instantly as a secure PDF once you pass the
                    final assessment (70% pass rate)
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1992">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-1993" />
                <div data-id="element-1994">
                  <p className="font-medium text-charcoal" data-id="element-1995">Inspection Ready</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-1996">
                    Valid for use as proof of training during inspections and
                    audits
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center p-4 bg-teal/10 rounded-lg" data-id="element-1997">
              <DownloadIcon className="h-6 w-6 text-teal mr-4" data-id="element-1998" />
              <p className="text-charcoal/80" data-id="element-1999">
                Your certificate is available for download immediately after
                completion and should be refreshed every 2–3 years
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-2000">
            <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200" data-id="element-2001">
              <img src="https://images.unsplash.com/photo-1571867424488-4565932edb41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Food Safety Certificate Ireland" className="w-full h-auto" data-id="element-2002" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border border-gray-100 max-w-xs" data-id="element-2003">
              <div className="flex items-center mb-3" data-id="element-2004">
                <div className="w-8 h-8 rounded-full bg-teal flex items-center justify-center mr-3" data-id="element-2005">
                  <BarChartIcon className="h-4 w-4 text-white" data-id="element-2006" />
                </div>
                <h4 className="font-bold text-charcoal" data-id="element-2007">Team Management</h4>
              </div>
              <p className="text-charcoal/70 text-sm" data-id="element-2008">
                For businesses, all team certificates are stored in your manager
                dashboard for easy access and compliance tracking during EHO
                inspections.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const FaqSection = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const toggleQuestion = questionId => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };
  const faqs = [{
    id: 1,
    question: 'Is food safety training mandatory in Ireland?',
    answer: 'Yes. All food handlers must complete food safety training that matches their work activity. Level 1 is the legal minimum for new employees in food businesses in Ireland, as required by the Food Safety Authority of Ireland (FSAI).'
  }, {
    id: 2,
    question: 'When must training be completed?',
    answer: 'According to FSAI requirements, Stage I induction training must be completed before food handling begins, and Stage II within the first month of employment. This course covers both stages to ensure full compliance.'
  }, {
    id: 3,
    question: 'How long does the certificate last?',
    answer: 'Certificates should be refreshed every 2–3 years or when legislation, company procedures, or your role changes. This is in line with FSAI best practice guidance for food businesses in Ireland.'
  }, {
    id: 4,
    question: 'Who recognises this certificate?',
    answer: 'The certificate is recognised by Irish employers, Environmental Health Officers (EHOs), and food safety inspectors as proof of compliance with FSAI guidelines. It can be presented during official inspections and audits.'
  }, {
    id: 5,
    question: 'Do I need Level 2 HACCP training?',
    answer: 'Yes, if you prepare or handle high-risk or open foods, you must complete Level 2 Food Safety (HACCP) training within 3 months of starting work. This is an additional requirement beyond the Level 1 training.'
  }, {
    id: 6,
    question: 'How do I access the course?',
    answer: 'Once enrolled, you can access the course immediately through our online learning platform. The course is 100% online and can be completed on any device with internet access - computer, tablet, or smartphone.'
  }, {
    id: 7,
    question: 'What happens if I fail the assessment?',
    answer: "You have unlimited attempts to pass the final assessment, which requires a 70% pass mark. If you don't pass, you can review the material and try again until you succeed, at no additional cost."
  }, {
    id: 8,
    question: 'Can I train my whole team?',
    answer: "Yes, our team enrollment option allows you to purchase multiple licenses and assign them to team members. You'll receive a free manager dashboard to track progress, monitor completions, and store certificates for your entire team."
  }];
  return <section className="py-20 bg-white" data-id="element-2009">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2010">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2011">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-2012">
            <ChevronDownIcon className="h-6 w-6 text-teal" data-id="element-2013" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-2014">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-2015">
            Find answers to common questions about our Level 1 Food Safety
            course for Ireland
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-2016">
          {faqs.map(faq => <div key={faq.id} className="mb-4 border border-gray-200 rounded-xl overflow-hidden" data-id="element-2017">
              <button onClick={() => toggleQuestion(faq.id)} className="flex items-center justify-between w-full p-6 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-2018">
                <h3 className="text-lg font-bold text-charcoal" data-id="element-2019">
                  {faq.question}
                </h3>
                {openQuestion === faq.id ? <MinusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-2020" /> : <PlusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-2021" />}
              </button>
              {openQuestion === faq.id && <div className="p-6 bg-gray-50 border-t border-gray-200" data-id="element-2022">
                  <p className="text-charcoal/80" data-id="element-2023">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="max-w-4xl mx-auto mt-12 text-center" data-id="element-2024">
          <p className="text-charcoal/70 mb-4" data-id="element-2025">
            Still have questions? We're here to help.
          </p>
          <a href="/contact" className="inline-flex items-center font-medium text-teal hover:text-aqua transition-colors" data-id="element-2026">
            Contact our support team
            <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-2027" />
          </a>
        </div>
      </div>
    </section>;
};
const CtaSection = () => {
  return <section className="py-20 bg-gradient-to-br from-teal to-teal/90 relative overflow-hidden" data-id="element-2028">
      <div className="absolute inset-0 overflow-hidden" data-id="element-2029">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-white/10 blur-3xl" data-id="element-2030"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full bg-white/5 blur-3xl" data-id="element-2031"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-2032">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2033">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 mb-6" data-id="element-2034">
            <CreditCardIcon className="h-8 w-8 text-white" data-id="element-2035" />
          </div>
          <h2 className="text-4xl font-bold mb-6 text-white tracking-tight" data-id="element-2036">
            Enroll Today – Start Your Level 1 Food Safety Training
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-3xl mx-auto" data-id="element-2037">
            Meet your legal requirements, protect your customers, and gain
            accredited certification with our Food Safety Level 1 Course for
            Ireland. Whether you're just starting out or refreshing your skills,
            this course provides the essential foundation for safe food
            handling.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-2038">
            <a href="#individual-enrollment" className="px-8 py-4 bg-white text-teal font-medium rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg" data-id="element-2039">
              Enroll Now
            </a>
            <a href="#team-enrollment" className="px-8 py-4 bg-transparent text-white font-medium rounded-lg border-2 border-white hover:bg-white/10 transition-all duration-300" data-id="element-2040">
              Team Training Options
            </a>
          </div>
          <div className="mt-10 flex flex-wrap justify-center gap-10" data-id="element-2041">
            <div className="flex flex-col items-center" data-id="element-2042">
              <div className="text-white/80 mb-2" data-id="element-2043">Instant Access</div>
              <div className="text-white font-medium" data-id="element-2044">Start Today</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-2045">
              <div className="text-white/80 mb-2" data-id="element-2046">FSAI Compliant</div>
              <div className="text-white font-medium" data-id="element-2047">Irish Certified</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-2048">
              <div className="text-white/80 mb-2" data-id="element-2049">Secure Payment</div>
              <div className="text-white font-medium" data-id="element-2050">256-bit SSL</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};